import type { FC } from 'react';
import styled from 'styled-components';
import { useColorTheme } from '../../../lib/hooks/useColorTheme/useColorTheme';
import MoonIcon_ from '../../../assets/Moon.svg';
import SunIcon_ from '../../../assets/Sun.svg';

type ThemeToggleButtonProps = {
  mobileOnly?: boolean;
};

export const ThemeToggleButton: FC<ThemeToggleButtonProps> = ({ mobileOnly = false }: ThemeToggleButtonProps) => {
  const { colorTheme, toggleColorTheme } = useColorTheme();
  const isDark = colorTheme === 'dark';

  return (
    <ToggleButton
      type="button"
      aria-label={isDark ? 'Light mode' : 'Dark mode'}
      onClick={toggleColorTheme}
      $mobileOnly={mobileOnly}
    >
      {isDark ? (
        <SunIcon_ viewBox="0 0 24 24" aria-hidden="true" />
      ) : (
        <MoonIcon_ viewBox="0 0 24 24" aria-hidden="true" />
      )}
    </ToggleButton>
  );
};

const ToggleButton = styled.button.withConfig({
  shouldForwardProp: (prop) => prop !== '$mobileOnly',
})<{ $mobileOnly: boolean }>`
  width: 38px;
  height: 38px;
  border: 1px solid transparent;
  border-radius: 999px;
  background: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  color: ${({ theme }) => theme.colors.prototype.mutedForeground};
  cursor: pointer;
  transition:
    background-color 180ms ease,
    border-color 180ms ease,
    color 180ms ease;

  &:hover {
    background: ${({ theme }) => theme.colors.topBarHoverBackground};
    color: ${({ theme }) => theme.colors.prototype.foreground};
  }

  @media (max-width: 768px) {
    display: ${({ $mobileOnly }) => ($mobileOnly ? 'inline-flex' : 'none')};
  }

  @media (min-width: 769px) {
    display: ${({ $mobileOnly }) => ($mobileOnly ? 'none' : 'inline-flex')};
  }
`;
